// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // urlSocket:'http://localhost:3000',
  // url:'http://ambienta.com.devel/api/',
  // video: 'http://ambienta.com.devel/storage/',
  // urlSocket:'https://conexion2.ambntamx.com/',
  // urlSocket:'https://conexion.enqentranos.com/',

  // urlSocket: 'https://conexion3.ambntamx.com/',

  // url:'https://api.ambntamx.com/api/',
  // url:'https://api.enqentranos.com/api/v2/',
  // urlimg: 'https://api.enqentranos.com/storage/',
  // urlserver:'https://api.ambientamx.com/api/',

  //  videoserver: 'https://api.ambientamx.com/storage/',

  //  urlimg: 'https://api2.ambntamx.com/storage/',
  //  url: 'https://api2.ambntamx.com/api/v2/' 
  //  url:'http://apiambientav2.com.devel/api/v2/',
  //  urlimg: 'http://apiambientav2.com.devel/storage/',



  // urlimg: 'https://api2.ambntamx.com/storage/',
  // url: 'https://api2.ambntamx.com/api/v2/' 


  // urlimg: 'https://api2.enqentranos.com/storage/',
  // url: 'https://api2.enqentranos.com/api/v2/' ,
  // urlSocket: 'https://conexion3.enqentranos.com/',

  urlimg: 'https://api2.ambntamx.com/storage/',
     url: 'https://api2.ambntamx.com/api/v2/',
     urlSocket: 'https://conexion5.ambntamx.com/',
     version: ' 2.3',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
